// extracted by mini-css-extract-plugin
var _1 = "CardModal_activity__bsdqJ";
var _2 = "CardModal_activityItem__qQWGi";
var _3 = "CardModal_addAttachmentButton__3gsbJ";
var _4 = "CardModal_alignCenter__dS75F";
var _5 = "CardModal_attachmentActions__xkhE3";
var _6 = "CardModal_buttonToggle__ryXpA";
var _7 = "CardModal_cardModalSlideIn__vzda5";
var _8 = "CardModal_cursorPointer__t6fNr";
var _9 = "CardModal_descriptionButton__-zAfk";
var _a = "CardModal_descriptionButtonText__EXASW";
var _b = "CardModal_descriptionText__r57zS";
var _c = "CardModal_dropdownMenu__R9hNE";
var _d = "CardModal_flexContainer__oei-z";
var _e = "CardModal_header__+Nab2";
var _f = "CardModal_headerCount__wEHB1";
var _10 = "CardModal_headerFirstLine__6f999";
var _11 = "CardModal_headerItem__AV22k";
var _12 = "CardModal_headerItems__Yj6FN";
var _13 = "CardModal_headerListField__f5TBr";
var _14 = "CardModal_headerListFieldIcon__ziRgG";
var _15 = "CardModal_headerListFieldWrapper__Qgk2U";
var _16 = "CardModal_headerNotificationsButton__V41zw";
var _17 = "CardModal_headerNotificationsIcon__BpJ7l";
var _18 = "CardModal_headerTitle__uDXT2";
var _19 = "CardModal_headerTitleWrapper__SrbnX";
var _1a = "CardModal_hint__WEYmQ";
var _1b = "CardModal_hr__dgNgI";
var _1c = "CardModal_iconAddButton__ridYu";
var _1d = "CardModal_iconAddButton2__JHoDS";
var _1e = "CardModal_lastUser__fWOfZ";
var _1f = "CardModal_linkIcon__4jwip";
var _20 = "CardModal_localChangesLoaded__4o8U5";
var _21 = "CardModal_mainContainer__dQo+b";
var _22 = "CardModal_moduleContainer__D5XN2";
var _23 = "CardModal_moduleHeader__b0c7q";
var _24 = "CardModal_moduleIcon__KX6oY";
var _25 = "CardModal_moreUsers__bHCdW";
var _26 = "CardModal_popupWrapper__v8i66";
var _27 = "CardModal_taskDueDateSummaryWrapper__cQBbr";
var _28 = "CardModal_text__SCB7P";
var _29 = "CardModal_user__2b1tm";
var _2a = "CardModal_wrapper__sYgdA";
export { _1 as "activity", _2 as "activityItem", _3 as "addAttachmentButton", _4 as "alignCenter", _5 as "attachmentActions", _6 as "buttonToggle", _7 as "cardModalSlideIn", _8 as "cursorPointer", _9 as "descriptionButton", _a as "descriptionButtonText", _b as "descriptionText", _c as "dropdownMenu", _d as "flexContainer", _e as "header", _f as "headerCount", _10 as "headerFirstLine", _11 as "headerItem", _12 as "headerItems", _13 as "headerListField", _14 as "headerListFieldIcon", _15 as "headerListFieldWrapper", _16 as "headerNotificationsButton", _17 as "headerNotificationsIcon", _18 as "headerTitle", _19 as "headerTitleWrapper", _1a as "hint", _1b as "hr", _1c as "iconAddButton", _1d as "iconAddButton2", _1e as "lastUser", _1f as "linkIcon", _20 as "localChangesLoaded", _21 as "mainContainer", _22 as "moduleContainer", _23 as "moduleHeader", _24 as "moduleIcon", _25 as "moreUsers", _26 as "popupWrapper", _27 as "taskDueDateSummaryWrapper", _28 as "text", _29 as "user", _2a as "wrapper" }
